import React, { useEffect, useState } from 'react';
import { TFunction } from 'next-i18next';

import { Product } from '@/features/livestream/detail/const';
import { AuctionStatus, PagePath, PriceSymbol } from '@/layouts/shared';
import { createHandle, getProductImage, toMoney } from '@/libs/app';
import { Link, Image, Button, Icon, AuctionIcon } from '@/components';
import { AuctionType } from '@/models/auction';
import { getAuctionInvitedUsers } from '@/features/livestream/detail/api';
import AuctionModal from './AuctionModal';

type ProductAuctionProps = {
  product: Product;
  productId: number;
  isDiscount: boolean;
  t: TFunction;
  userId: number;
};
const ProductAuction = ({
  product,
  productId,
  isDiscount,
  t,
  userId,
}: ProductAuctionProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [isInvited, setIsInvited] = useState<boolean>(false);
  const handleOpenModal = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (product.auction?.id) {
      if (product.auction.type === AuctionType.InvitedOnly) {
        getAuctionInvitedUsers(product.auction?.id).then(({ data }) => {
          setIsInvited(!!data);
        });
      } else {
        setIsInvited(true);
      }
    }
  }, [product]);

  return (
    <>
      <div className="tw-bg-white tw-rounded-5 tw-p-2">
        <div className=" tw-flex tw-gap-x-2">
          <Link
            url={{
              pathname: PagePath.ProductDetailPage,
              query: {
                id: `${createHandle(product.product_name)}-${productId}-${
                  product.product_code
                }`,
              },
            }}
          >
            <div
              className="tw-relative !tw-w-20 !tw-h-20 tw-bg-center tw-bg-no-repeat tw-bg-cover tw-rounded-5"
              style={{
                backgroundImage: `url('${getProductImage(product.images)}')`,
              }}
              title={product.product_name}
            >
              {isDiscount && (
                <>
                  <div className="tw-w-6 tw-h-6 tw-absolute tw-top-2 tw-right-2">
                    <Image
                      src="/sale.png"
                      className="tw-w-full tw-h-full"
                      alt="sale"
                    ></Image>
                  </div>
                </>
              )}
            </div>
          </Link>
          <div className="tw-flex-1 tw-flex tw-flex-col tw-gap-y-1">
            <Link
              className="tw-w-full"
              url={{
                pathname: PagePath.ProductDetailPage,
                query: {
                  id: `${createHandle(product.product_name)}-${productId}-${
                    product.product_code
                  }`,
                },
              }}
            >
              <h4
                className="tw-text-primary-main tw-text-sm tw-font-semibold tw-line-clamp-1"
                dangerouslySetInnerHTML={{ __html: product.product_name }}
              />
            </Link>
            <div className="tw-text-13 ">
              <span className="tw-text-secondary-70">
                {product.product_code}
              </span>
              -
              <i>
                Giá khởi điểm:{' '}
                <span className="tw-text-warning-90 tw-font-semibold">
                  {toMoney(
                    product.auction?.origin_price || 0,
                    t,
                    PriceSymbol.$
                  )}
                </span>
              </i>
            </div>
            <div className="tw-text-sm">
              <i>
                Giá hiện tại:{' '}
                <span className="tw-text-warning-90 tw-font-semibold">
                  {toMoney(product.auction?.sell_price || 0, t, PriceSymbol.$)}
                </span>
              </i>
            </div>
          </div>
        </div>
        <div className="tw-flex tw-justify-end">
          <Button
            onClick={handleOpenModal}
            disabled={
              product.auction?.status !== AuctionStatus.Started ||
              !userId ||
              !isInvited
            }
            className="tw-bg-warning-90 tw-text-white tw-uppercase tw-flex tw-items-center tw-gap-x-2 tw-border-warning-90 tw-text-xs tw-w-max tw-px-6 tw-py-1"
          >
            <Icon icon={<AuctionIcon />} />
            <span>Đấu giá</span>
          </Button>
        </div>
      </div>
      {open && productId && (
        <AuctionModal
          t={t}
          handleCloseModal={() => setOpen(false)}
          productCode={product.product_code}
          productName={product.product_name}
          productId={productId}
        />
      )}
    </>
  );
};

export default ProductAuction;
